module.exports = __webpack_public_path__ + "img/sec3_lang_img5.b613b7a3.png";